import { css } from 'lit';

export const baseStyles = css`
  :host {
    box-sizing: border-box;
  }

  :host * {
    box-sizing: border-box;
  }

  p {
    max-width: 90ch;
  }

  p:last-child {
    margin-bottom: 0;
  }

  .flex-list {
    display: flex;
    flex-wrap: wrap;
    column-gap: var(--s-spacer);
  }

  h3.page-title {
    color: var(--uui-color-default);
    font-size: 32px;
  }

  @media (min-width: 992px) {
    h3.page-title {
      margin-top: 0;
      text-align: center;
    }
  }

  .alert {
    padding: var(--xs-spacer);
    position: relative;
    border-radius: var(--uui-border-radius);
  }

  .alert > * {
    z-index:500;
    position:relative;
  }

  .alert > p {
    margin:0;
  }

  .alert + .alert {
    margin-top: var(--s-spacer);
  }

  .alert-info {
    background-color: var(--uui-color-surface);
  }
`;
